import React from 'react';

import { DefaultFooter } from '@ant-design/pro-components';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={`Copyright © ${new Date().getFullYear()} Scoutech Medical`}
    />
  );
};

export default Footer;
